module.exports = __webpack_public_path__ + "img/global.21ac90ac.png";